export default __webpack_public_path__ + "static/media/CERT1-1.f770af7a.png";